import { Icon } from '~/lib/data-contract';

export type SpriteProps = {
	name: Icon;
};

export const Sprite = ({ name, ...props }: SpriteProps) => (
	<svg
		width="25px"
		height="25px"
		viewBox="0 0 25 25"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<use href={`/assets/sprite.svg#${name}`}></use>
	</svg>
);
